/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, utils } from "ethers";
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "tokenX",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "tokenY",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint24",
                name: "fee",
                type: "uint24",
            },
            {
                indexed: false,
                internalType: "uint24",
                name: "pointDelta",
                type: "uint24",
            },
            {
                indexed: false,
                internalType: "address",
                name: "pool",
                type: "address",
            },
        ],
        name: "NewPool",
        type: "event",
    },
    {
        inputs: [],
        name: "chargeReceiver",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "defaultFeeChargePercent",
        outputs: [
            {
                internalType: "uint24",
                name: "",
                type: "uint24",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "deployPoolParams",
        outputs: [
            {
                internalType: "address",
                name: "tokenX",
                type: "address",
            },
            {
                internalType: "address",
                name: "tokenY",
                type: "address",
            },
            {
                internalType: "uint24",
                name: "fee",
                type: "uint24",
            },
            {
                internalType: "int24",
                name: "currentPoint",
                type: "int24",
            },
            {
                internalType: "int24",
                name: "pointDelta",
                type: "int24",
            },
            {
                internalType: "uint24",
                name: "feeChargePercent",
                type: "uint24",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint24",
                name: "fee",
                type: "uint24",
            },
            {
                internalType: "uint24",
                name: "pointDelta",
                type: "uint24",
            },
        ],
        name: "enableFeeAmount",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint24",
                name: "fee",
                type: "uint24",
            },
        ],
        name: "fee2pointDelta",
        outputs: [
            {
                internalType: "int24",
                name: "pointDelta",
                type: "int24",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "flashModule",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "limitOrderModule",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "liquidityModule",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_chargeReceiver",
                type: "address",
            },
        ],
        name: "modifyChargeReceiver",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint24",
                name: "_defaultFeeChargePercent",
                type: "uint24",
            },
        ],
        name: "modifyDefaultFeeChargePercent",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tokenX",
                type: "address",
            },
            {
                internalType: "address",
                name: "tokenY",
                type: "address",
            },
            {
                internalType: "uint24",
                name: "fee",
                type: "uint24",
            },
            {
                internalType: "int24",
                name: "currentPoint",
                type: "int24",
            },
        ],
        name: "newPool",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tokenX",
                type: "address",
            },
            {
                internalType: "address",
                name: "tokenY",
                type: "address",
            },
            {
                internalType: "uint24",
                name: "fee",
                type: "uint24",
            },
        ],
        name: "pool",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "swapX2YModule",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "swapY2XModule",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
export class IiZiSwapFactory__factory {
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
IiZiSwapFactory__factory.abi = _abi;
